import React, { Component } from "react";
import axios from "axios";
import Image from "react-bootstrap/Image";
import { NavLink } from "react-router-dom";
import RightSidePannel from "../../../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import NoMapSetupScreen from "../../MapSetupScreen/NoMapSetupScreen";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import { submit_map_details } from "../../../../../../store/reducers/dataStorage/storageAction";

export class NoMapSetupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      lat: "",
      lng: "",
      errors: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        //console.log(result.data)
        this.setState({
          lat: result.data.latitude,
          lng: result.data.longitude,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  onMapYesButton = (e) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        this.setState({
          lat: lat,
          lng: lng,
        });
        localStorage.setItem("manual_autodetect_no", true);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  onSubmitHandler = (e) => {
    const formData = {
      lat: this.state.lat,
      lng: this.state.lng,
    };
    console.log(formData);
    this.props.submit_map_details(formData);
    this.props.history.push("/restaurantsettings");
  };

  render() {
    const lat = this.state.lat;
    const lng = this.state.lng;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left">
              <div className="col-12 onboarding_process_screen_left-backbutton">
                <NavLink to="/mapsetup" className="back_button-link">
                  <Image
                    src={require("../../../../../../assets/images/Icon/onBoardBack.png")}
                    alt="Back Button"
                    title="Back Button"
                  />
                </NavLink>
              </div>
              <div className="onboarding_process_screen-left-mapinside">
                <div>
                  <div className="display-toggle-stepup-button">
                    <RightSidePannel selectedTab={this.state.selectedTab} />
                  </div>
                  <TopTextReusableComponent
                    headingText="Map Setup"
                    headingParagraph="Restaurant names on Amealio need to be written as they appear on the board outside the restaurant"
                  />
                </div>
                <div className="onboarding-map-setup-screen-inside-map">
                  <h5 className="onboarding-map-setup-headingtext">
                    Drop a pin to your address
                  </h5>
                  <div className="d-flex align-items-center">
                    {/* <LocationDetectionPopup
                      onConfirmClickOne={(e) =>
                        (window.location.href = "/autodetectmap")
                      }
                    /> */}
                    <div className="d-flex align-items-center">
                      <Image
                        src={require("../../../../../../assets/images/onboarding/autodetect.png")}
                        fluid
                        alt="Auto Detect"
                        title="Auto Detect"
                        className="location-detections-popup-map-search"
                        onClick={this.onMapYesButton}
                      />
                      <p
                        onClick={this.onMapYesButton}
                        className="onboarding-map-setup-paragraphtext"
                      >
                        Auto Detect Location
                      </p>
                    </div>
                  </div>
                </div>
                <div className="onboarding-map-setup-screen-inside-map-box-body">
                  {lat !== undefined &&
                  lat !== "" &&
                  lng !== undefined &&
                  lng !== "" ? (
                    <NoMapSetupScreen
                      google={this.props.google}
                      center={{
                        lat: parseFloat(lat),
                        lng: parseFloat(lng),
                      }}
                      height="65vh"
                      zoom={15}
                    />
                  ) : null}
                </div>
                <div className="onboarding-map-setup-screen-autodetect-button">
                  {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/mapsetup"
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonText="Next"
                    buttonType="button"
                    onClick={this.onSubmitHandler}
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  />
                  {/* </div> */}
                </div>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_right">
              <RightSidePannel
                selectedTab={this.state.selectedTab}
                headingText="Store Setup"
                imageSrc={require("../../../../../../assets/images/onboarding/storeSetup.svg")}
                paragraph="Enter information diligently about your food establishment. Users
                  would like to know about your restaurant listed on our app. Take your
                  time and fill information carefully"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

NoMapSetupComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  submit_map_details,
})(withRouter(NoMapSetupComponent));
